export const contingentRefreshIcon = {
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><path d="M5.156 9.625c-2.062 0-3.781-1.719-3.781-3.781 0-2.063 1.719-3.782 3.781-3.782.825 0 1.513.276 2.2.688H5.5v1.375h4.125V0H8.25v1.719C7.356 1.03 6.325.687 5.156.687 2.338.688 0 3.026 0 5.845 0 8.662 2.337 11 5.156 11c2.819 0 5.157-2.338 5.157-5.156H8.937c0 2.062-1.718 3.781-3.78 3.781z" fill="#1A80BA"/></svg>`,
  name: 'refresh',
};
